module.exports = __webpack_public_path__ + "img/skull_3_bj.8945172a.png";